import React from "react";
import { Handshake, Mail } from "lucide-react";

function Contact() {
    return (
        <div className="flex flex-col items-center justify-center w-full py-4 px-5 lg:px-12 xl:px-12 rounded-lg">
        <div className="rounded-full mb-4 p-3 bg-gray-800 border border-gray-500">
            <Handshake className="w-10 h-10 text-blue-500" />
        </div>

        <h1 className="font-semibold text-lg">Let's work together</h1>
        <p className="text-gray-400 text-center">Let's bring your ideas to existence</p>

        <a
            href="mailto:alexiselerio00@gmail.com"
            className="mt-2 p-2 w-full bg-blue-600 hover:bg-blue-500 duration-300 rounded-2xl flex gap-2 items-center justify-center flex-1 text-white"
        >
            <Mail className="w-5 h-5" />
            <p>Email me</p>
        </a>

        <a
            href="https://m.me/mewodark"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 p-2 w-full bg-gray-800 hover:bg-gray-700 duration-300 rounded-2xl flex gap-2 items-center justify-center flex-1 text-white"
        >
            <svg className='w-5 h-5 text-white' viewBox="0 0 192 192" xmlns="http://www.w3.org/2000/svg" fill="none"> <g id="SVGRepo_bgCarrier" strokeWidth={0} /> <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" /> <g id="SVGRepo_iconCarrier"> {" "} <g stroke="currentColor" strokeLinejoin="round" strokeWidth={12} clipPath="url(#a)" > {" "} <path d="M148.326 43.674c-28.899-28.899-75.753-28.899-104.652 0-25.014 25.014-28.377 63.481-10.087 92.112l-4.336 22.272c-.542 2.784 1.907 5.233 4.691 4.691l22.272-4.336c28.631 18.29 67.098 14.927 92.112-10.087 28.899-28.899 28.899-75.753 0-104.652Z" />{" "} <path strokeLinecap="round" d="m131.355 83.272-24.041 24.042-21.92-21.92-24.042 24.041" />{" "} </g>{" "} <defs> {" "} <clipPath id="a"> {" "} <path fill="currentColor" d="M0 0h192v192H0z" />{" "} </clipPath>{" "} </defs>{" "} </g> </svg>
            <p>Messenger</p>
        </a>
        </div>
    );
}

export default Contact;
